import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';

import { IResultSet } from '../models';
import {
  IActivitySearchFilterCounts,
  IActivitySearchQueryAndFilters,
  IActivitySearchResult,
} from '../models/activity-search';
import { LoadingIndicatorService } from './loading-indicator.service';

@Injectable({ providedIn: 'root' })
export class ActivitySearchService {
  private http = inject(HttpClient);
  private loadingIndicatorService = inject(LoadingIndicatorService);

  private _baseUrl = '/api/activity-search';

  searchForPersonPaged(
    searchQueryAndFilters: IActivitySearchQueryAndFilters,
  ): Observable<IResultSet<IActivitySearchResult[]>> {
    this.loadingIndicatorService.forceLoadingState(true);
    return this.http
      .post<
        IResultSet<IActivitySearchResult[]>
      >(`${this._baseUrl}/terms/person`, searchQueryAndFilters)
      .pipe(
        finalize(() => {
          this.loadingIndicatorService.forceLoadingState(false);
        }),
      );
  }

  getFilterCounts(searchQueryAndFilters: IActivitySearchQueryAndFilters) {
    return this.http.post<IActivitySearchFilterCounts>(
      `${this._baseUrl}/filter-counts`,
      searchQueryAndFilters,
    );
  }
}
